var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinned = function SvgPinned(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pinned_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pinned_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pinned_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "pinned_svg__st1",
    d: "M7.62 0h8.77v14H7.62z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "pinned_svg__st1",
    d: "M17.14 2H6.87c-.55 0-1-.45-1-1s.45-1 1-1h10.27c.55 0 1 .45 1 1s-.45 1-1 1zM18.37 14H5.63c-.56 0-.84-.77-.45-1.23l2.25-2.56c.12-.13.28-.21.45-.21h8.24c.17 0 .33.08.45.21l2.25 2.56c.39.46.11 1.23-.45 1.23z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "pinned_svg__st1",
    d: "M12 24c-.43 0-.79-.47-.83-1.09l-.61-9.61c-.04-.7.34-1.3.83-1.3h1.22c.49 0 .88.6.83 1.3l-.61 9.61c-.04.62-.4 1.09-.83 1.09z"
  })));
};
export default SvgPinned;